// Controller werden hier explizit registriert (esbuild-Bundling).
import { application } from "./application"

import CostController from "./cost_controller"
application.register("cost", CostController)
